export default "__VITE_ASSET__Dd72d9rF__"